(function ($) {

$(document).ready(function(){
  	$('#shopify-section-1548965337055').removeClass('fadeIn');
  	$('#shopify-section-1548965337055').removeClass('wow');
  	$('#shopify-section-1548965337055').removeClass('shopify-section');
  	setTimeout(function(){
    	$('#shopify-section-1548965337055').css('visibility', 'visible');
    }, 500)
  
  
  	setTimeout(function(){
  		$('.snpt-load-more').remove();
      	$('.snptwdgt-rtd__ftr').remove();
  	}, 1000)
  
  	//set active header states
  	var currentURL = window.location.href;
  	currentURL = currentURL.split('/');
  	var currentPage = currentURL.pop();
  if(currentPage == 'customer-service'){
  	$('a.customerServiceLink').css('color', '#f58673');
  }else if(currentPage.indexOf('search') >= 0){
  	$('i.header_icon_search img').attr('src', 'https://cdn.shopify.com/s/files/1/0062/6006/4369/t/2/assets/TopNav_Search_Active.svg?657715781816601280');
  }else if(currentPage == 'login'){
    $('i.header_icon_account img').attr('src', 'https://cdn.shopify.com/s/files/1/0062/6006/4369/t/2/assets/TopNav_Account_Active.svg?657715781816601280');
  }else if(currentPage == 'account'){
    $('i.header_icon_account img').attr('src', 'https://cdn.shopify.com/s/files/1/0062/6006/4369/t/2/assets/TopNav_Account_Active.svg?657715781816601280');
  }else if(currentPage == 'addresses'){
    $('i.header_icon_account img').attr('src', 'https://cdn.shopify.com/s/files/1/0062/6006/4369/t/2/assets/TopNav_Account_Active.svg?657715781816601280');
  }else if(currentPage == 'cart'){
    $('span.header_icon_bag img.emptyBag').attr('src', 'https://cdn.shopify.com/s/files/1/0062/6006/4369/t/2/assets/Bag_Empty_Hover.svg?2079704381646199870');
    $('span.header_icon_bag img.fullBag').attr('src', 'https://cdn.shopify.com/s/files/1/0062/6006/4369/t/2/assets/Bag_Full_Hover.svg?14772518079683880027');
  }
  	
  
  
	
    
    
    var accHead = $(".accordion div.accordionHead");
  
  $('body').on('click', '.accordion div.accordionHead', function(e){
    if($(this).hasClass('active')){
    	$(this).siblings('.accordionContent').stop().slideUp();
      	$(this).children('div').children('img').css({
        	"-webkit-transform": "rotate(360deg)",
    		"-moz-transform": "rotate(360deg)",
    		"transform": "rotate(360deg)" /* For modern browsers(CSS3)  */
        });
      	$(this).removeClass('active');
    }else{
    	$(this).siblings('.accordionContent').stop().slideDown();
      	$(this).children('div').children('img').css({
        	"-webkit-transform": "rotate(180deg)",
    		"-moz-transform": "rotate(180deg)",
    		"transform": "rotate(180deg)" /* For modern browsers(CSS3)  */
        });
    	$(this).addClass('active');
    }
  })
  
  
  $('#olive-jewelry a.search-show i').click(function(e){
   	e.preventDefault();
    if(!$('#site-header').hasClass('activeBackground') && $('#top-search-wrapper').hasClass('expanded')){
    	$('#site-header').css('background', 'transparent');
    }else if($('#site-header').hasClass('activeBackground') && $('#top-search-wrapper').hasClass('expanded')){
    	// do nothing
    }else{
    	$('#site-header').css('background', '#fff');
    }
  })
  
  //mega menu functions
  
  $('.megaTrigger').click(function(e){
  	e.preventDefault();
    $this = $(this);
    $megaMenu = $('.megaMenu');
    if($this.hasClass('megaActive')){
      $('.showing').css('opacity', '0');
      $megaMenu.animate({
        top:'-280%'
      }, 300, function(){
        if(!$('#site-header').hasClass('activeBackground')){
        	$('#site-header').css('background','transparent');
        }
        $('.showing').css('display', 'none');
        $('.showing').removeClass('showing');
        $megaMenu.hide();
        $('.megaTrigger').removeClass('megaActive');
        
      })
    }else{
      	$this.parent().siblings().children('a').removeClass('megaActive');
        $this.addClass('megaActive');
        tarID = $this.attr('id').split('-');
        megaID = tarID[1].toLowerCase();
        $menuItems = $('.' + megaID + 'Mega');
		
        if($('.megaBlock').hasClass('showing')){
           $('.showing').animate({
                'opacity':0
            }, 300, function(){
                $('.showing').hide();
                $menuItems.addClass('showing');
                $menuItems.show();
                $menuItems.animate({
                  'opacity':1
                }, 300, function(){})
            })	   
        }else{
          if(!$('#site-header').hasClass('activeBackground')){
		  	$('#site-header').css('background','#fff');
          }
          $menuItems.addClass('showing');

          $megaMenu.show();
          $menuItems.show();


          $megaMenu.animate({
            'top': '100%'
          }, 500, function(){
            $menuItems.animate({
              'opacity':1
            }, 500, function(){})
          })
        }
    }
    
  })
  
  //end mega menu functions
//   orderPos = $('#ordersPayments').position();
//   shipPos = $('#shipping').position();
//   carePos = $('#careRepair').position();
//   sizingPos = $('#sizing').position();
//   categoryPos = $('#category').position();
//   ipsumPos = $('#ipsum').position();
  
  var sectionPositions = [];
  var menuItems = [];
  
  $('.sectionHead').each(function(el, EL){
  	sectionPositions.push($(this).position());
  })
  $('.orderLink').each(function(el, EL){
  	menuItems.push($(this).attr('href'));
  })
  
    $('body').on('click', '.orderLink', function(e){
      	e.preventDefault();
    	var matchId = $(this).attr('href');
      	var matchIdx = $.inArray(matchId, menuItems);
      	$('.accordion div.active').siblings('.accordionContent').slideUp()
        $('.accordion div.active div').children('img').css({
        	"-webkit-transform": "rotate(360deg)",
    		"-moz-transform": "rotate(360deg)",
    		"transform": "rotate(360deg)" /* For modern browsers(CSS3)  */
        });
        $('html').animate({
          scrollTop:sectionPositions[matchIdx].top
        }, 500);
    })
  
  
//   $('.orderLink').click(function(e){
//     e.preventDefault();
//     $('.accordion div.active').siblings('.accordionContent').slideUp()
//     $('html').animate({
//       scrollTop:orderPos.top
//     }, 500);

//     $('.faqMenu ul li a').removeClass('activeSection');
//     $(this).addClass('activeSection');
//   })
//   $('.shipLink').click(function(e){
//     e.preventDefault();
//     $('.accordion div.active').siblings('.accordionContent').slideUp()
//     $('html').animate({
//       scrollTop:shipPos.top
//     }, 500);
//     $('.faqMenu ul li a').removeClass('activeSection');
//     $(this).addClass('activeSection');
//   })
//   $('.careLink').click(function(e){
//     e.preventDefault();
//     $('.accordion div.active').siblings('.accordionContent').slideUp()
//     $('html').animate({
//       scrollTop:carePos.top
//     }, 500);
//     $('.faqMenu ul li a').removeClass('activeSection');
//     $(this).addClass('activeSection');
//   })
//   $('.sizeLink').click(function(e){
//     e.preventDefault();
//     $('.accordion div.active').siblings('.accordionContent').slideUp()
//     $('html').animate({
//       scrollTop:sizingPos.top
//     }, 500);
//     $('.faqMenu ul li a').removeClass('activeSection');
//     $(this).addClass('activeSection');
//   })
//   $('.catLink').click(function(e){
//     e.preventDefault();
//     $('.accordion div.active').siblings('.accordionContent').slideUp()
//     $('html').animate({
//       scrollTop:categoryPos.top
//     }, 500);
//     $('.faqMenu ul li a').removeClass('activeSection');
//     $(this).addClass('activeSection');
//   })
//   $('.ipLink').click(function(e){
//     e.preventDefault();
//     $('.accordion div.active').siblings('.accordionContent').slideUp()
//     $('html').animate({
//       scrollTop:ipsumPos.top
//     }, 500);
//     $('.faqMenu ul li a').removeClass('activeSection');
//     $(this).addClass('activeSection');
//   })
  //customer service scroll functions
  
  
  
  //end customer service scroll functions
  
  //filter hide function
  $('.filterCollapse').click(function(e){
    if($('.filtersContainer').hasClass('opened')){
    	$('.filtersContainer').slideUp();
      	$('.filtersContainer').removeClass('opened');
      	$('.filtersContainer').addClass('closed');
      	//$('.filterCollapse span.filterCaret').css('float', 'right');
      	$('.filterCollapse span.filterCaret img').addClass('rotateImg');
    }else if($('.filtersContainer').hasClass('closed')){
    	$('.filtersContainer').slideDown();
      	$('.filtersContainer').addClass('opened');
      	$('.filtersContainer').removeClass('closed');
        $('.filterCollapse span.filterCaret img').removeClass('rotateImg');
      	//$('.filterCollapse span.filterCaret').css('float', 'none');
    }
  })
  
  setTimeout(function(){
  	$('.snptcrd').hover(function(){
  		var $this = $(this);
      	$this.append('<div class="instaHover"><img src="https://cdn.shopify.com/s/files/1/0062/6006/4369/t/10/assets/insta_icon.svg?v=1634021586"/><p>Shop Now</p></div>');
      	$('.snptcrd__ovrly').remove();
//       	$('.instaHover img').css({
//           'height':'70%',
//           'margin-bottom':'20px'
//       	})
//         $('.instaHover p').css({
//           'font-size':'18px',
//           'text-transform':'uppercase',
//           'color':'#fff',
//           'font-family':'Qualion-DemiBold'
//         })
//       	$('.instaHover').css({
//           'height':'81%',
//           'width':'81%',
//           'background':'rgba(245, 134, 115, 0.8)',
//           'color':'#fff',
//           'padding':'100px 50px',
//           'position':'absolute',
//           'top':'35px',
//           'left':'35px'
//       	})
    },
    function(){
		$('.instaHover').remove();
    })
  }, 1700)
  
  $('#shopify-section-1540925991843').removeClass('fadeIn');
  
  $('.mobile-menu').on('click', '.mobileAccordion', function(e){
    e.preventDefault();
    var $this = $(this);
    var plusImg = 'https://cdn.shopify.com/s/files/1/0062/6006/4369/t/2/assets/Menu_Plus.svg?2282788911391936088';
    var minImg = 'https://cdn.shopify.com/s/files/1/0062/6006/4369/t/2/assets/Menu_Minus.svg?9485651690426339669';
    $this.siblings('ul').stop();
    if($this.hasClass('opened')){
      $this.removeClass('opened');
      $this.siblings('ul').slideUp();
      $this.children().children().attr('src', plusImg);
    }else{
      $this.siblings('ul').slideDown();
      $this.addClass('opened');
      $this.children().children().attr('src', minImg);
    }
  })
  
  $('.site-dropdown-plus').click(function () {
    $(this).hide().next().show();
    $(this).parent('li').find('.mobile-sub-category').slideDown();
  });
  $('.site-dropdown-minus').click(function () {
    $(this).hide().prev().show();
    $(this).parent('li').find('.mobile-sub-category').slideUp();
  });
    
})

})(window.wetheme.$);